import { FC, useCallback, useContext, useMemo } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import set from 'lodash/set';

import { OnboardingWizardContext } from '@modules/Onboarding/contexts/OnboardingWizardContext/OnboardingWizardContext';
import { ValuesForm } from '@modules/Objectives/partials/ValuesForm/ValuesForm';


type Props = {
  onComplete: () => void;
  onBack?: () => void;
};

export const ValuesStep: FC<Props> = (props) => {
  const { onComplete, onBack } = props;
  const { data, setData } = useContext(OnboardingWizardContext);

  const onValueChange = useCallback((fieldPath: string, value: any) => {
    const updatedData = set({ ...data }, `preferences.${fieldPath}`, value);
    setData(updatedData);
  }, [data, setData]);

  const defaultValues = useMemo(() => {
    return {
      leadershipValue1: data?.preferences?.leadershipValue1 || '',
      leadershipValue2: data?.preferences?.leadershipValue2 || '',
      leadershipValue3: data?.preferences?.leadershipValue3 || '',
    };
  }, [data?.preferences]);

  return (
    <Box>
      <Stack gap={2}>
        <Typography variant="body2" textAlign="center" fontSize={12} color="text.secondary" mb={3}>Excellent progress! Now your values.</Typography>
        <Typography variant="body1" textAlign="center" fontSize={30} fontWeight={600}>
          Leadership (optional)
        </Typography>
        <Typography variant="body2" textAlign="center" color="text.secondary" fontSize={16}>
          Share your core values to better understand your leadership style, or skip to dive straight into storytelling.
        </Typography>
      </Stack>

      <ValuesForm
        defaultValues={defaultValues}
        onFieldChange={onValueChange}
        onSubmitRequest={onComplete}
        slots={{
          footer: (formState) => (
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Button
                variant="outlined"
                startIcon={<ArrowBack/>}
                size="large"
                onClick={onBack}
              >
                Back
              </Button>
              <Button
                variant="contained"
                type="submit"
                endIcon={<ArrowForward/>}
                size="large"
              >
                {formState.isDirty ? 'Continue to Story' : 'Skip to Story'}
              </Button>
            </Stack>
          ),
        }}
      />
    </Box>
  );
};
